//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';
import ngRedux, { INgReduxProvider, Middleware } from 'ng-redux';
import { Action, combineReducers } from 'redux';
import thunk, { ThunkDispatch } from 'redux-thunk';

import { ICuralateStore } from '@models/AppState';

import { loggerReduxMiddleware } from 'app/logger/loggerReduxMiddleware';

import reducers from './curalate.store.root-reducer';

interface IReduxDevtoolsHost {
  __REDUX_DEVTOOLS_EXTENSION__?: () => () => unknown;
}

export default angular.module('curalate.store', [ngRedux]).config([
  '$ngReduxProvider',
  ($ngReduxProvider: INgReduxProvider) => {
    const devTools = (window as unknown as IReduxDevtoolsHost)
      .__REDUX_DEVTOOLS_EXTENSION__;
    const enhancers: (() => unknown)[] = [];
    if (devTools && typeof devTools === 'function') {
      enhancers.push(devTools());
    }
    // TODO: Add reduxjs-toolkit middleware:
    // This will enable immutability & serialization checking in dev mode
    // Until we fix how we deal with `Date`s it will spam many warnings
    // getDefaultMiddleware({ thunk: false })
    $ngReduxProvider.createStoreWith(
      combineReducers(reducers),
      [loggerReduxMiddleware, thunk as unknown as Middleware],
      enhancers,
    );
  },
]);

export type ReduxDispatch = ThunkDispatch<ICuralateStore, unknown, Action>;
export type ReduxGetState = () => ICuralateStore;
